document.addEventListener('DOMContentLoaded', function () {
    "use strict";

    // Select Layout option functionality
    const radioButtons = document.querySelectorAll('input[name="display_option"]');
    let currentDisplayOption = 'all';

    // Add event listeners to radio buttons for dynamic filtering
    radioButtons.forEach(button => {
        button.addEventListener('change', function () {
            currentDisplayOption = this.value;
            updateOptions(currentDisplayOption);
            // Don't save yet, wait for user to select a specific layout option
        });
    });
    
    // Add event listeners to all select buttons
    document.querySelectorAll('.zwssgr-select-btn').forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Remove 'selected' class from all buttons
            document.querySelectorAll('.zwssgr-select-btn').forEach(btn => {
                btn.classList.remove('selected');
            });
            
            // Add 'selected' class to the clicked button
            this.classList.add('selected');
            
            // Get the layout option and display option from the button's data attributes
            const layoutOption = this.getAttribute('data-option');
            const displayOption = this.getAttribute('data-display-option');
            
            // Save the selected options
            saveSelectedOption(displayOption, layoutOption);
        });
    });

    // Function to save the selected display option and layout option via AJAX
    function saveSelectedOption(displayOption, layoutOption) {
        let postId = getQueryParam('zwssgr_widget_id');
        let settings = document.querySelector('.tab-item.active')?.getAttribute('data-tab');
        
        // Ensure we have valid values
        if (!postId || !displayOption || !layoutOption) {
            console.error("Missing required parameters for saving options");
            return;
        }

        // First, send the AJAX request to save the widget data
        let xhr = new XMLHttpRequest();
        xhr.open('POST', ajaxurl, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        
        let params = new URLSearchParams({
            action: 'zwssgr_save_widget_data',
            security: my_widget.nonce,
            display_option: displayOption,
            layout_option: layoutOption,
            post_id: postId,
            settings: settings
        });
        
        xhr.onload = function () {
            if (xhr.status === 200) {
                // console.log('Display and layout option saved successfully');
                
                // Now send the AJAX request to update the shortcode
                let updateXhr = new XMLHttpRequest();
                updateXhr.open('POST', ajaxurl, true);
                updateXhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                
                let updateParams = new URLSearchParams({
                    action: 'zwssgr_update_shortcode',
                    post_id: postId,
                    layout: displayOption,
                    layout_option: layoutOption
                });
                
                updateXhr.onload = function () {
                    if (updateXhr.status === 200) {
                        // console.log('Shortcode updated successfully');
                        
                        // Redirect to the selected option tab
                        let currentUrl = window.location.href.split('?')[0];
                        let newUrl = `${currentUrl}?page=zwssgr_widget_configurator&tab=tab-selected&selectedOption=${layoutOption}&zwssgr_widget_id=${postId}`;
                        window.location.href = newUrl;
                    } else {
                        console.error('Error updating shortcode:', updateXhr.statusText);
                    }
                };
                
                updateXhr.onerror = function () {
                    console.error('Shortcode update request failed');
                };
                
                updateXhr.send(updateParams.toString());
            } else {
                console.error('Error saving options:', xhr.statusText);
            }
        };
        
        xhr.onerror = function () {
            console.error('Request failed');
        };
        
        xhr.send(params.toString());
    }

    // Function to show/hide options based on the selected radio button
    function updateOptions(value) {
        document.querySelectorAll('.zwssgr-option-item').forEach(item => {
            if (value === 'all' || item.dataset.type === value) {
                item.style.display = 'block';
            } else {
                item.style.display = 'none';
            }
        });
    }

    // Function to get query parameter by name
    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }  

    // Set active tab and selected option from the URL
    window.zwssgrActiveTab = getQueryParam('tab') || 'tab-options'; // Default to 'tab-options'
    window.zwssgrSelectedOption = getQueryParam('selectedOption'); // Get the selected option ID from URL


    // Hide all tab content
    document.querySelectorAll('.zwssgr-tab-content').forEach(function (tab) {
        tab.style.display = 'display';
    });

    // Show the active tab content
    let activeTabElement = document.getElementById(window.zwssgrActiveTab);
    if (activeTabElement) {
        activeTabElement.style.display = 'block';
    }

    // Remove 'active' class from all tab items
    document.querySelectorAll('.tab-item').forEach(function (tabItem) {
        tabItem.classList.remove('active');
    });

    // Add 'active' class to the selected tab item
    let activeTabItem = document.querySelector('.tab-item[data-tab="' + window.zwssgrActiveTab + '"]');
    if (activeTabItem) {
        activeTabItem.classList.add('active');
    }

    // If there's a selected option in the URL and the active tab is 'tab-selected'
    if (window.zwssgrSelectedOption && window.zwssgrActiveTab === 'tab-selected') {
        let selectedOptionElement = document.getElementById(window.zwssgrSelectedOption);
        let selectedOptionDisplay = document.getElementById('selected-option-display');

        if (selectedOptionElement && selectedOptionDisplay) {
            selectedOptionDisplay.innerHTML = ''; // Clear previous content
            selectedOptionDisplay.appendChild(selectedOptionElement); // Move the selected option
            
            // Remove the select button from the moved element
            let selectBtn = selectedOptionDisplay.querySelector('.select-btn');
            if (selectBtn) {
                selectBtn.remove();
            }
        }
    }


    // Handle click events for the tab navigation items
    document.addEventListener('click', function(event) {
        if (event.target.classList.contains('tab-item')) {
            let tabId = event.target.getAttribute('data-tab');
            let currentUrl = window.location.href.split('?')[0]; // Get the base URL

            // Get existing query parameters
            let selectedOption = getQueryParam('selectedOption'); // Keep the selected option in URL if it exists
            let postId = getQueryParam('zwssgr_widget_id'); // Get the post_id from the URL if it exists

            // Start building the new URL with page and tab parameters
            let newUrl = `${currentUrl}?page=zwssgr_widget_configurator&tab=${tabId}`;

            // Add selectedOption to the URL if it exists
            if (selectedOption) {
                newUrl += `&selectedOption=${selectedOption}`;
            }

            // Add post_id to the URL if it exists
            if (postId) {
                newUrl += `&zwssgr_widget_id=${postId}`;
            }

            // Redirect to the new URL
            window.location.href = newUrl;
        }
    });

});